import React, { useEffect, useState } from "react";
import _ from "lodash";
import { FieldArray } from "formik";
import { Table } from "react-bootstrap";
import {
  CustomArrayTextField,
  CustomOutlinedDisabledNoMarginTextField,
} from "../../../../../partials/content/Forms";
import {
  FormArrayDateField,
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import PrItemForm from "./prItemForm";
import { DialogActions, InputAdornment, TextField } from "@material-ui/core";
import SearchItemUom from "../../items/searchItemUom";
import { KeyboardDatePicker } from "@material-ui/pickers";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
function ReceiveItem({
  values,
  transferID = 0,
  poID = 0,
  warehouseID = 0,
  touched,
  errors,
  setFieldValue,
  setFieldError,
  handleChange,
  handleBlur,
}) {
  const [openReservation, setOpenReservation] = useState(false);
  const [itemReceive, setItemReceive] = useState({});
  const [itemIndex, setItemIndex] = useState(0);
  const [itemIndexSplit, setItemIndexSplit] = useState(-1);
  const [openBatchVariant, setOpenBatchVariant] = useState(false);
  const [batchVariant, setBatchVariant] = useState([]);
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [itemSelected, setItemSelected] = useState({
    itemID: 0,
    qtyReceived: 0,
    qtyRemaining: 0,
    uomID: 0,
    uomName: "",
  });
  useEffect(() => {}, []);
  return (
    <FieldArray name="itemList">
      {({ push, remove }) => (
        <React.Fragment>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="card">
                <Table borderless size="sm" responsive="xl">
                  <thead className="text-center">
                    <tr>
                      <th style={{ width: "25%" }}>Item Name</th>
                      <th style={{ width: "10%" }}>Received Quantity</th>
                      {transferID === 0 ? (
                        <th style={{ width: "10%" }}>Remaining Quantity</th>
                      ) : null}
                      <th style={{ width: "10%" }}>Unit</th>
                      <th style={{ width: "10%" }}>Batch Code</th>
                      {poID > 0 ? (
                        <>
                          <th style={{ width: "20%" }}>Production Date</th>
                          <th style={{ width: "20%" }}>Expiry Date</th>
                          <th>Actions</th>
                        </>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    {values.itemList && values.itemList.length > 0
                      ? values.itemList.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <tr>
                                <td>
                                  <FormOutlinedNoMarginTextField
                                    value={`${item.itemCode} ${item.itemName}`}
                                    InputProps={{
                                      startAdornment:
                                        item.itemType > 0 ? (
                                          <InputAdornment position="start">
                                            <BootstrapTooltip
                                              title={item.itemTypeName}
                                            >
                                              <i
                                                className={
                                                  item.itemType === 1
                                                    ? "fas fa-boxes text-success"
                                                    : item.itemType === 2
                                                    ? "fas fa-tools text-primary"
                                                    : item.itemType === 3
                                                    ? "fas fa-building text-info"
                                                    : item.itemType === 4
                                                    ? "fas fa-boxes text-warning"
                                                    : item.itemType === 5
                                                    ? "fas fa-boxes text-danger"
                                                    : null
                                                }
                                              ></i>
                                            </BootstrapTooltip>
                                          </InputAdornment>
                                        ) : null,
                                      readOnly: true,
                                    }}
                                  />
                                </td>
                                <td>
                                  {item.itemsTransferID > 0 ? (
                                    <FormArrayTextField
                                      arrayPropName="itemList"
                                      index={index}
                                      propName="qtyReceived"
                                      quantityField
                                      margin="none"
                                      readonly
                                    />
                                  ) : (
                                    <FormArrayTextField
                                      arrayPropName="itemList"
                                      index={index}
                                      propName="qtyReceived"
                                      quantityField
                                      margin="none"
                                      onBlur={(value) => {
                                        if (
                                          item.purchaseRequests &&
                                          item.purchaseRequests.length > 0
                                        ) {
                                          item.purchaseRequests.forEach(
                                            (pr, indexPr) => {
                                              setFieldValue(
                                                `itemList[${index}].purchaseRequests[${indexPr}].qtyReserve`,
                                                0
                                              );
                                            }
                                          );
                                        }
                                      }}
                                    />
                                  )}
                                </td>
                                {transferID === 0 ? (
                                  <td>
                                    <FormArrayTextField
                                      arrayPropName="itemList"
                                      index={index}
                                      propName="qtyRemaining"
                                      quantityField
                                      margin="none"
                                      readonly
                                    />
                                  </td>
                                ) : null}
                                <td>
                                  <FormArrayTextField
                                    arrayPropName="itemList"
                                    index={index}
                                    propName="uomName"
                                    margin="none"
                                    readonly
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName="itemList"
                                    index={index}
                                    propName="batchCode"
                                    margin="none"
                                    readonly={transferID > 0 ? true : false}
                                  />
                                </td>
                                {poID > 0 &&
                                (item.itemType === 1 ||
                                  item.itemType === 4 ||
                                  item.itemType === 5) ? (
                                  <>
                                    <td>
                                      <FormArrayDateField
                                        arrayPropName="itemList"
                                        index={index}
                                        propName="productionDate"
                                      />
                                    </td>
                                    <td>
                                      <FormArrayDateField
                                        arrayPropName="itemList"
                                        index={index}
                                        propName="expiryDate"
                                      />
                                    </td>
                                    <td
                                      style={{ whiteSpace: "nowrap" }}
                                      className="text-center"
                                    >
                                      {item.splitInd === false ? (
                                        <BootstrapTooltip title="Split Batch">
                                          <button
                                            type="button"
                                            className="btn btn-icon btn-label-info btn-md 
                                            btn-circle mx-1"
                                            onClick={() => {
                                              let itemBatchListTmp = [];
                                              if (
                                                values.itemList[index]
                                                  .batchSplitList &&
                                                values.itemList[index]
                                                  .batchSplitList.length > 0
                                              ) {
                                                itemBatchListTmp = [
                                                  ...values.itemList[index]
                                                    .batchSplitList,
                                                ];
                                              }
                                              itemBatchListTmp.push({
                                                index,
                                                ID: item.ID,
                                                purchaseOrderItemID:
                                                  item.purchaseOrderItemID,
                                                twarehouseID: warehouseID,
                                                itemID: item.itemID,
                                                itemName: item.itemName,
                                                varCode: item.varCode,
                                                qtyReceived: 0,
                                                uomID: item.uomID,
                                                uomName: item.uomName,
                                                productionDate: null,
                                                expiryDate: null,
                                                purchaseRequests:
                                                  item.purchaseRequests,
                                                splitInd: true,
                                                itemType: item.itemType,
                                                batchVariantValue:
                                                  item.batchVariantValueIn,
                                              });
                                              setFieldValue(
                                                `itemList[${index}].batchSplitList`,
                                                itemBatchListTmp
                                              );
                                            }}
                                          >
                                            <i className="fas fa-code-branch"></i>
                                          </button>
                                        </BootstrapTooltip>
                                      ) : (
                                        <BootstrapTooltip title="Delete Batch Split Item">
                                          <button
                                            type="button"
                                            className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                            onClick={() => {
                                              remove(index);
                                            }}
                                          >
                                            <i className="fas fa-trash-alt"></i>
                                          </button>
                                        </BootstrapTooltip>
                                      )}
                                    </td>
                                  </>
                                ) : null}
                              </tr>
                              <BatchList
                                values={values}
                                item={item}
                                touched={touched}
                                errors={errors}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                setItemReceive={setItemReceive}
                                setItemIndexSplit={setItemIndexSplit}
                                setOpenReservation={setOpenReservation}
                                setBatchVariant={setBatchVariant}
                                setOpenBatchVariant={setOpenBatchVariant}
                                setFieldError={setFieldError}
                                setFieldValue={setFieldValue}
                              />
                            </React.Fragment>
                          );
                        })
                      : null}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          <DialogLayout
            open={openReservation}
            title="Items Reservation"
            onCloseDialog={() => {
              setOpenReservation(false);
            }}
            maxWIdth="lg"
          >
            <PrItemForm
              itemReceive={itemReceive}
              onCloseDialog={() => {
                setOpenReservation(false);
              }}
              onSaveData={(reservations) => {
                const itemList = [...values.itemList];
                if (itemIndexSplit >= 0) {
                  itemList[itemIndex].batchSplitList[
                    itemIndexSplit
                  ].purchaseRequests = reservations;
                } else {
                  itemList[itemIndex].purchaseRequests = reservations;
                }
                setFieldValue("itemList", itemList);
                setOpenReservation(false);
              }}
            />
          </DialogLayout>
          <DialogLayout
            open={openBatchVariant}
            title="Batch Variant"
            onCloseDialog={() => {
              setBatchVariant([]);
              setOpenBatchVariant(false);
            }}
            //fullScreen={false}
            maxWIdth="lg"
          >
            <div className="card">
              <Table striped borderless hover size="sm" responsive="xl">
                <tbody>
                  {batchVariant && batchVariant.length > 0
                    ? batchVariant.map((itemBatch, indexVariant) => {
                        return (
                          <tr key={indexVariant}>
                            <th>{itemBatch.varName}</th>
                            <td>
                              {itemBatch.dataType === 1 ? (
                                <TextField
                                  name="stringValue"
                                  value={itemBatch.stringValue}
                                  margin="none"
                                  variant="outlined"
                                  size="small"
                                  onChange={(e) => {
                                    const batchVariantTmp = [...batchVariant];
                                    batchVariantTmp[indexVariant].stringValue =
                                      e.target.value;
                                    setBatchVariant(batchVariantTmp);
                                  }}
                                  fullWidth
                                />
                              ) : itemBatch.dataType === 2 ? (
                                <KeyboardDatePicker
                                  autoOk
                                  inputVariant="outlined"
                                  variant="inline"
                                  name="dateValue"
                                  value={itemBatch.dateValue}
                                  format="yyyy-MM-dd"
                                  onChange={(date) => {
                                    const batchVariantTmp = [...batchVariant];
                                    batchVariantTmp[
                                      indexVariant
                                    ].dateValue = date;
                                    setBatchVariant(batchVariantTmp);
                                  }}
                                  InputProps={{ readOnly: true }}
                                />
                              ) : null}
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </Table>
            </div>
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setBatchVariant([]);
                  setOpenBatchVariant(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
              <button
                type="button"
                className="btn btn-success btn-md btn-pill btn-bold"
                onClick={() => {
                  const itemList = [...values.itemList];
                  if (itemIndexSplit >= 0) {
                    itemList[itemIndex].batchSplitList[
                      itemIndexSplit
                    ].batchVariantValue = batchVariant;
                  } else {
                    itemList[itemIndex].batchVariantValue = batchVariant;
                  }
                  setFieldValue("itemList", itemList);
                  setBatchVariant([]);
                  setOpenBatchVariant(false);
                }}
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchUom}
            title="Search Unit of Measurement"
            onCloseDialog={() => {
              setOpenSearchUom(false);
            }}
            maxWIdth="sm"
          >
            {itemSelected.itemID > 0 ? (
              <SearchItemUom
                itemID={itemSelected.itemID}
                onSelectUom={(uom) => {
                  switch (uom.uom) {
                    case "DAY":
                      break;

                    default:
                      break;
                  }
                  setFieldValue(`itemList[${itemIndex}].uomID`, uom.ID);
                  setFieldValue(`itemList[${itemIndex}].uomName`, uom.uom);
                  setOpenSearchUom(false);
                }}
              />
            ) : null}
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchUom(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </React.Fragment>
      )}
    </FieldArray>
  );
}

function BatchList({
  values,
  item,
  touched,
  errors,
  handleChange,
  handleBlur,
  setItemReceive,
  setItemIndexSplit,
  setOpenReservation,
  setBatchVariant,
  setOpenBatchVariant,
  setFieldError,
  setFieldValue,
}) {
  return (
    <React.Fragment>
      {item.batchSplitList && item.batchSplitList.length > 0
        ? item.batchSplitList.map((itemSplit, indexSplit) => {
            return (
              <React.Fragment key={indexSplit}>
                <tr>
                  <td></td>
                  <td>
                    <CustomArrayTextField
                      arrayName={`itemList[${itemSplit.index}].batchSplitList`}
                      inputType="number"
                      propertyName="qtyReceived"
                      margin="none"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        handleChange(e);
                        if (
                          item.purchaseRequests &&
                          item.purchaseRequests.length > 0
                        ) {
                          item.purchaseRequests.forEach((pr, indexPr) => {
                            setFieldValue(
                              `itemList[${indexSplit}].purchaseRequests[${indexPr}].qtyReserve`,
                              0
                            );
                          });
                        }
                      }}
                      index={indexSplit}
                      value={itemSplit}
                      touched={touched}
                      errors={errors}
                    />
                  </td>
                  <td></td>
                  <td>
                    <CustomOutlinedDisabledNoMarginTextField
                      value={item.uomName}
                    />
                  </td>
                  <td>
                    <KeyboardDatePicker
                      disableToolbar
                      autoOk={true}
                      variant="inline"
                      inputVariant="outlined"
                      format="yyyy-MM-dd"
                      margin="none"
                      fullWidth
                      value={itemSplit.productionDate}
                      size="small"
                      onChange={(date) => {
                        setFieldValue(
                          `itemList[${itemSplit.index}].batchSplitList[${indexSplit}].productionDate`,
                          date
                        );
                      }}
                      InputProps={{ readOnly: true }}
                    />
                  </td>
                  <td>
                    <KeyboardDatePicker
                      disableToolbar
                      autoOk={true}
                      variant="inline"
                      inputVariant="outlined"
                      format="yyyy-MM-dd"
                      margin="none"
                      fullWidth
                      value={itemSplit.expiryDate}
                      size="small"
                      onChange={(date) => {
                        setFieldValue(
                          `itemList[${itemSplit.index}].batchSplitList[${indexSplit}].expiryDate`,
                          date
                        );
                      }}
                      InputProps={{ readOnly: true }}
                    />
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="text-center">
                    <BootstrapTooltip title="Delete Batch Split Item">
                      <button
                        type="button"
                        className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                        onClick={() => {
                          let batchSplitList = [];
                          batchSplitList = [...item.batchSplitList];
                          batchSplitList = _.remove(batchSplitList, function(
                            value,
                            indexArr
                          ) {
                            return indexSplit !== indexArr;
                          });
                          setFieldValue(
                            `itemList[${itemSplit.index}].batchSplitList`,
                            batchSplitList
                          );
                        }}
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </td>
                </tr>
              </React.Fragment>
            );
          })
        : null}
    </React.Fragment>
  );
}

export default ReceiveItem;
